module.exports = __webpack_public_path__ + "img/shareBg.f01e0240.png";